module.exports = __webpack_public_path__ + "fonts/emoji-ic03.svg";